import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
	REGISTER_MERCHANT,
	REGISTER_MERCHANT_SUCCESS,
	REGISTER_MERCHANT_FAILED,
	VIEW_MERCHANT,
	VIEW_MERCHANT_SUCCESS,
	VIEW_MERCHANT_FAILED,
	SEARCH_SUB_MERCHANT,
	SEARCH_SUB_MERCHANT_SUCCESS,
	SEARCH_SUB_MERCHANT_FAILED,
	UPDATE_MERCHANT,
	UPDATE_MERCHANT_SUCCESS,
	UPDATE_MERCHANT_FAILED,
	BACK_TO_LOGIN,
	VERIFICATION_MERCHANT,
	VERIFICATION_MERCHANT_FAILED,
	VERIFICATION_MERCHANT_SUCCESS,
	VERIFICATION_FORGOT_MERCHANT,
	VERIFICATION_FORGOT_MERCHANT_SUCCESS,
	VERIFICATION_FORGOT_MERCHANT_FAILED,
	VERIFICATION_FORGOT_PASSWORD_MERCHANT,
	VERIFICATION_FORGOT_PASSWORD_MERCHANT_SUCCESS,
	VERIFICATION_FORGOT_PASSWORD_MERCHANT_FAILED,
	SEARCH_MERCHANT,
	SEARCH_MERCHANT_SUCCESS,
	SEARCH_MERCHANT_FAILED,
	MERCHANT_PAYMENT_TYPE,
	MERCHANT_PAYMENT_TYPE_SUCCESS,
	MERCHANT_PAYMENT_TYPE_FAILED,
} from "constants/ActionTypes";
import {
	registerMerchantApi,
	registerSandboxMerchantApi,
	viewMerchantApi,
	searchSubMerchantApi,
	getListCurrencyApi,
	// getCurrencyApi,
	updateMerchantApi,
	verificationMerchantApi,
	verificationForgotMerchantApi,
	verificationForgotPasswordMerchantApi,
	activateSandboxApi,
	searchMerchantApi,
	merchantPaymentTypeApi,
} from "../../appRedux/api/Merchant";
import {
	ACTIVATE_SANDBOX,
	ACTIVATE_SANDBOX_FAILED,
	ACTIVATE_SANDBOX_SUCCESS,
} from "../../constants/ActionTypes";
import {
	GET_LIST_CURRENCY,
	GET_LIST_CURRENCY_SUCCESS,
	GET_LIST_CURRENCY_FAILED,
} from "constants/ActionTypes";
import { GET_CURRENCY, GET_CURRENCY_SUCCESS, GET_CURRENCY_FAILED } from "constants/ActionTypes";
import {
	CURRENCY_MERCHANT,
	CURRENCY_MERCHANT_SUCCESS,
	CURRENCY_MERCHANT_FAILED,
} from "constants/ActionTypes";
import {
	SEARCH_MERCHANT_IS_EXCHANGE,
	SEARCH_MERCHANT_IS_EXCHANGE_SUCCESS,
	SEARCH_MERCHANT_IS_EXCHANGE_FAILED,
} from "../../constants/ActionTypes";
import {
	legacyCurrencyPayload,
	legacyMerchantSearchList,
} from "../../appRedux/api/idpHelpers";
import {
	apiHandler,
	AUTH_PASSWORD_FORGOT_SUCCESS,
	AUTH_PASSWORD_RESET_SUCCESS,
	IDP_INQUIRY_SUCCESS,
	IDP_MUTATION_SUCCESS,
	IDP_REGISTRATION_VERIFY_SUCCESS,
} from "./handler";
import { validatePasswordPolicy, PASSWORD_POLICY_MESSAGE } from "../../util/util";

function* postRegisterMerchant({ payload }) {
	if (payload == null) {
		return;
	}

	if (payload.rootRegister === "sandbox") {
		try {
			const registerMerchantData = yield call(registerSandboxMerchantApi, payload);
			if (registerMerchantData.data.abstractResponse.responseStatus === "MER020") {
				yield put({ type: REGISTER_MERCHANT_SUCCESS, payload: registerMerchantData.data });
			} else {
				yield put({
					type: REGISTER_MERCHANT_FAILED,
					payload: registerMerchantData.data.abstractResponse.responseMessage,
				});
			}
		} catch (error) {
			const data = error.response && error.response.data;
			const abstract = data && data.abstractResponse;
			yield put({
				type: REGISTER_MERCHANT_FAILED,
				payload:
					(abstract && abstract.responseMessage) ||
					(data && data.responseMessage) ||
					"Sorry, this feature is not accessible at this time.",
			});
		}
		return;
	}

	const { ok, data, message } = yield* apiHandler(registerMerchantApi, payload, {
		successCodes: ["MER020"],
		suppressAuthRedirect: true,
	});

	if (ok) {
		yield put({ type: REGISTER_MERCHANT_SUCCESS, payload: data });
	} else {
		yield put({ type: REGISTER_MERCHANT_FAILED, payload: message });
	}
}

export function* fetchViewMerchant({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(viewMerchantApi, payload, {
			successCodes: ['MER019', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({ type: VIEW_MERCHANT_SUCCESS, payload: data.body });
		} else {
			yield put({ type: VIEW_MERCHANT_FAILED, payload: message });
		}
	}
}

export function* fetchSearchSubMerchant({ payload }) {
	if (payload != null) {
		try {
			let searchSubMerchantData = yield call(searchSubMerchantApi, payload);
			if (searchSubMerchantData.data.abstractResponse.responseStatus === "INQ000") {
				yield put({
					type: SEARCH_SUB_MERCHANT_SUCCESS,
					payload: searchSubMerchantData.data.subMerchantList.merchants,
				});
			} else {
				yield put({
					type: SEARCH_SUB_MERCHANT_FAILED,
					payload: searchSubMerchantData.data.abstractResponse.responseMessage,
				});
			}
		} catch (error) {
			if (error.response !== undefined) {
				if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
					yield put({
						type: BACK_TO_LOGIN,
						payload: error.response.data.abstractResponse.responseMessage,
					});
				} else {
					yield put({
						type: SEARCH_SUB_MERCHANT_FAILED,
						payload: error.response.data.abstractResponse.responseMessage,
					});
				}
			} else {
				yield put({
					type: SEARCH_SUB_MERCHANT_FAILED,
					payload: "Sorry, this feature is not accessible at this time.",
				});
			}
		}
	}
}

function* fetchListCurrency({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(getListCurrencyApi, payload, {
			successCodes: ['INQ000', 'CURRENCY02', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({ type: GET_LIST_CURRENCY_SUCCESS, payload: legacyCurrencyPayload(data) });
		} else {
			yield put({ type: GET_LIST_CURRENCY_FAILED, payload: message });
		}
	}
}

function* fetchCurrency({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(getListCurrencyApi, payload, {
			successCodes: ['INQ000', 'CURRENCY02', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({ type: GET_CURRENCY_SUCCESS, payload: legacyCurrencyPayload(data) });
		} else {
			yield put({ type: GET_CURRENCY_FAILED, payload: message });
		}
	}
}

function* fetchCurrencyMerchant({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(getListCurrencyApi, payload, {
			successCodes: ['INQ000', 'CURRENCY02', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({ type: CURRENCY_MERCHANT_SUCCESS, payload: legacyCurrencyPayload(data) });
		} else {
			yield put({ type: CURRENCY_MERCHANT_FAILED, payload: message });
		}
	}
}

function* postUpdateMerchant({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(updateMerchantApi, payload, {
			successCodes: ['MER017', ...IDP_MUTATION_SUCCESS],
		});

		if (ok) {
			yield put({
				type: UPDATE_MERCHANT_SUCCESS,
				payload: data.body || data.merchant,
			});
		} else {
			yield put({ type: UPDATE_MERCHANT_FAILED, payload: message });
		}
	}
}

function* postVerificationMerchant({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(verificationMerchantApi, payload, {
			successCodes: IDP_REGISTRATION_VERIFY_SUCCESS,
			suppressAuthRedirect: true,
		});

		if (ok) {
			yield put({
				type: VERIFICATION_MERCHANT_SUCCESS,
				payload: data.body || {},
			});
		} else {
			yield put({ type: VERIFICATION_MERCHANT_FAILED, payload: message });
		}
	}
}

function* postVerificationForgotMerchant({ payload }) {
	if (payload != null) {
		const { ok, message } = yield* apiHandler(verificationForgotMerchantApi, payload, {
			successCodes: AUTH_PASSWORD_FORGOT_SUCCESS,
			suppressAuthRedirect: true,
		});

		if (ok) {
			yield put({ type: VERIFICATION_FORGOT_MERCHANT_SUCCESS, payload: {} });
		} else {
			yield put({ type: VERIFICATION_FORGOT_MERCHANT_FAILED, payload: message });
		}
	}
}

function* postVerificationForgotPasswordMerchant({ payload }) {
	if (payload != null) {
		if (!validatePasswordPolicy(payload.password)) {
			yield put({
				type: VERIFICATION_FORGOT_PASSWORD_MERCHANT_FAILED,
				payload: PASSWORD_POLICY_MESSAGE,
			});
			return;
		}

		const { ok, message } = yield* apiHandler(
			verificationForgotPasswordMerchantApi,
			payload,
			{
				successCodes: AUTH_PASSWORD_RESET_SUCCESS,
				suppressAuthRedirect: true,
			},
		);

		if (ok) {
			yield put({ type: VERIFICATION_FORGOT_PASSWORD_MERCHANT_SUCCESS, payload: {} });
		} else {
			yield put({ type: VERIFICATION_FORGOT_PASSWORD_MERCHANT_FAILED, payload: message });
		}
	}
}

function* postActivateSandbox({ payload }) {
	if (payload != null) {
		try {
			const registerSandboxData = yield call(registerSandboxMerchantApi, payload);
			if (registerSandboxData.data.abstractResponse.responseStatus !== "MER020") {
				yield put({
					type: ACTIVATE_SANDBOX_FAILED,
					payload: registerSandboxData.data.abstractResponse.responseMessage,
				});
				return;
			}
		} catch (error) {
			const data = error.response && error.response.data;
			const abstract = data && data.abstractResponse;
			yield put({
				type: ACTIVATE_SANDBOX_FAILED,
				payload:
					(abstract && abstract.responseMessage) ||
					(data && data.responseMessage) ||
					"Sorry, this feature is not accessible at this time.",
			});
			return;
		}

		const { ok, data, message } = yield* apiHandler(activateSandboxApi, payload, {
			successCodes: ["MER023", "MER022", ...IDP_MUTATION_SUCCESS],
		});

		if (ok) {
			yield put({
				type: ACTIVATE_SANDBOX_SUCCESS,
				payload: data.responseMessage || "Sandbox activated",
			});
		} else {
			yield put({ type: ACTIVATE_SANDBOX_FAILED, payload: message });
		}
	}
}

export function* fetchSearchMerchant({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(searchMerchantApi, payload, {
			successCodes: ['MER002', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({
				type: SEARCH_MERCHANT_SUCCESS,
				payload: legacyMerchantSearchList(data),
			});
		} else {
			yield put({ type: SEARCH_MERCHANT_FAILED, payload: message });
		}
	}
}

export function* fetchMerchantPayment({ payload }) {
	if (payload != null) {
		try {
			let merchantPaymentType = yield call(merchantPaymentTypeApi, payload);
			// if (merchantPaymentType.data.abstractResponse.responseStatus === "MER002") {
			yield put({
				type: MERCHANT_PAYMENT_TYPE_SUCCESS,
				payload: merchantPaymentType.data.sourceOfFund,
			});
			// } else {
			// 	yield put({
			// 		type: MERCHANT_PAYMENT_TYPE_FAILED,
			// 		payload: merchantPaymentType.data.abstractResponse.responseMessage,
			// 	});
			// }
		} catch (error) {
			if (error.response !== undefined) {
				if (error.response.data.abstractResponse.responseStatus === "AUTH001") {
					yield put({
						type: BACK_TO_LOGIN,
						payload: error.response.data.abstractResponse.responseMessage,
					});
				} else {
					yield put({
						type: MERCHANT_PAYMENT_TYPE_FAILED,
						payload: error.response.data.abstractResponse.responseMessage,
					});
				}
			} else {
				yield put({
					type: MERCHANT_PAYMENT_TYPE_FAILED,
					payload: "Sorry, this feature is not accessible at this time.",
				});
			}
		}
	}
}

export function* fetchSearchMerchantIsExchange({ payload }) {
	if (payload != null) {
		const { ok, data, message } = yield* apiHandler(searchMerchantApi, payload, {
			successCodes: ['MER002', ...IDP_INQUIRY_SUCCESS],
		});

		if (ok) {
			yield put({
				type: SEARCH_MERCHANT_IS_EXCHANGE_SUCCESS,
				payload: legacyMerchantSearchList(data),
			});
		} else {
			yield put({ type: SEARCH_MERCHANT_IS_EXCHANGE_FAILED, payload: message });
		}
	}
}

export function* registerMerchant() {
	yield takeEvery(REGISTER_MERCHANT, postRegisterMerchant);
}

export function* viewMerchant() {
	yield takeEvery(VIEW_MERCHANT, fetchViewMerchant);
}

export function* searchSubMerchant() {
	yield takeEvery(SEARCH_SUB_MERCHANT, fetchSearchSubMerchant);
}

export function* getListCurrency() {
	yield takeEvery(GET_LIST_CURRENCY, fetchListCurrency);
}

export function* getCurrency() {
	yield takeEvery(GET_CURRENCY, fetchCurrency);
}

export function* getCurrencyMerchant() {
	yield takeEvery(CURRENCY_MERCHANT, fetchCurrencyMerchant);
}

export function* updateMerchant() {
	yield takeEvery(UPDATE_MERCHANT, postUpdateMerchant);
}

export function* verificationMerchant() {
	yield takeEvery(VERIFICATION_MERCHANT, postVerificationMerchant);
}

export function* verificationForgotMerchant() {
	yield takeEvery(VERIFICATION_FORGOT_MERCHANT, postVerificationForgotMerchant);
}

export function* verificationForgotPasswordMerchant() {
	yield takeEvery(VERIFICATION_FORGOT_PASSWORD_MERCHANT, postVerificationForgotPasswordMerchant);
}

export function* activateSandbox() {
	yield takeEvery(ACTIVATE_SANDBOX, postActivateSandbox);
}

export function* searchMerchant() {
	yield takeEvery(SEARCH_MERCHANT, fetchSearchMerchant);
}

export function* merchantPaymentType() {
	yield takeEvery(MERCHANT_PAYMENT_TYPE, fetchMerchantPayment);
}

export function* searchMerchantIsExchange() {
	yield takeEvery(SEARCH_MERCHANT_IS_EXCHANGE, fetchSearchMerchantIsExchange);
}

// yield all
export default function* rootSaga() {
	yield all([
		fork(registerMerchant),
		fork(viewMerchant),
		fork(searchSubMerchant),
		fork(getListCurrency),
		fork(getCurrency),
		fork(getCurrencyMerchant),
		fork(updateMerchant),
		fork(verificationMerchant),
		fork(verificationForgotMerchant),
		fork(verificationForgotPasswordMerchant),
		fork(activateSandbox),
		fork(searchMerchant),
		fork(merchantPaymentType),
		fork(searchMerchantIsExchange),
	]);
}
